const backendBase = process.env.BACKEND_BASE;

const isImage = (object) => object?.mime?.startsWith("image/");

/**
 * Recursively changes the image URL in the given object and its nested objects.
 *
 * @param {Object} object - the object to traverse and update image URLs
 * @param {string} key - the key of the current object field
 * @param {Object} parent - the parent object of the current object
 */
export default async function changeImageUrl(object = {}, key = "", parent = {}) {
  if (!object) return;

  if (object?.mime && object?.url?.startsWith("/")) {
    //if it is an image, keep an object
    if (isImage(object)) {
      object.url = backendBase + object.url;
    }

    //if not, transform the object into an image url
    if (key && !isImage(object)) {
      parent[key] = backendBase + object.url;
    }
  }

  if (object && Array.isArray(object)) {
    for (let i = 0; i < object.length; i++) {
      await changeImageUrl(object[i], `${i}`, object);
    }
  }

  if (typeof object === "object") {
    for (const key in object) {
      await changeImageUrl(object[key], key, object);
    }
  }
}
